/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CompositeSearchEnhancedFilterConditionType {
    EQUAL = 'EQUAL',
    NOT_EQUAL = 'NOT_EQUAL',
}
